import React, { useEffect, useState } from 'react';
import Cart from '../Cart/Cart';
import Product from '../Product/Product';
import './Shop.css'

const Shop = () => {

    const [tickets, setTicket] = useState([])
    const [cart, setCart] = useState([])

    useEffect(() => {
        fetch('./person.JSON')
            .then(res => res.json())
            .then(data => setTicket(data))
    }, [])

    const hanleAddtoCart = (ticket) => {
        const newCart = [...cart, ticket]
        setCart(newCart)
    }
    return (
        <div className="container mb-4">
            <div className="row">
                <div className="col-lg-9 col-md-8 col-sm-12">
                    <div className="row ">
                        {
                            tickets.map(ticket => <Product key={ticket.id} ticket={ticket} hanleAddtoCart={hanleAddtoCart}></Product>)
                        }

                    </div>

                </div>
                <div className="col-lg-3 cart card pt-3 col-md-4 col-sm-12">   
                       
                    <Cart cart={cart}></Cart>
                </div>
            </div>

        </div>
    );
};

export default Shop;